<template>
  <div class="fab-container">
    <div class="fab-btn" @click="handleClick">
      <span><i class="fas fa-qrcode" aria-hidden="true"></i></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fab-button',
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.fab-container {
  position: fixed;
  bottom: 4vh;
  right: 2vh;
  z-index: 1;
}
.fab-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background: #F05F97;
  border-radius: 50%;/*角丸*/
  opacity: 0.9;
}
.fab-btn i {
  color: #fff;
  font-size: 32px;
}

@media screen and (min-width:480px) {
  .fab-container {
    bottom: 8vh;
    right: 4vh;
  }
  .fab-btn {
    width: 100px;
    height: 100px;
  }
  .fab-btn i {
    font-size: 48px;
  }
}
</style>
